import { ProfileType } from '@lhb/api/engagement-gateway/index';

export function getIcon(profileType: ProfileType) {
  switch (profileType) {
    case ProfileType.COMPANY:
      return 'farm';
    default:
      return 'user';
  }
}
